<template>
    <section>
        <Search />
        <b-row>
            <b-col
                cols="12"
                md="6"
            >
                <SearchedFbaProducts />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
                <FbaBasketProducts />
            </b-col>
        </b-row>
        <FbaBarcode />
    </section>
</template>

<script>
    import Search from '@/views/amazon/fba-basket/Search.vue'
    import SearchedFbaProducts from '@/views/amazon/fba-basket/SearchedFbaProducts.vue'
    import FbaBasketProducts from '@/views/amazon/fba-basket/FbaBasket/FbaBasketProducts.vue'
    import FbaBarcode from '@/views/amazon/fba-basket/FbaBarcode.vue'

    export default {
        name: 'FbaBasketHome',
        components: {
            Search,
            SearchedFbaProducts,
            FbaBasketProducts,
            FbaBarcode,
        },
    }
</script>
